var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"busy-bar"},[_vm._l((_vm.parsedRanges),function(ref,index){
var bind = ref.bind;
var range = ref.range;
return _c('div',_vm._b({key:index,staticClass:"range"},'div',bind,false),[_vm._t("range",null,{"range":range,"index":index})],2)}),_vm._l((_vm.conflicts),function(item,index){return _c('div',_vm._b({key:'c:' + index,staticClass:"conflict range"},'div',item.bind,false),[_vm._t("conflict",null,{"conflict":item.conflict,"index":index})],2)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }